import React from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import SVG from 'react-inlinesvg';

import './index.css';
import { toggleVacancyModal } from '../../actions';
import Button from '../button';
import closeModal from '../../images/vacancies/closeModal.svg';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0',
    maxHeight: "calc(100vh - 100px)",
    overflowY: "scroll",
    overflowX: 'hidden'
  },
  overlay: {
    position: "fixed",
    top: "0px",
    left: "0px",
    right: "0px",
    bottom: "0px",
    backgroundColor: "rgba(0,0,0,.2)",
    zIndex: '100'
  }
};

Modal.setAppElement('#root');

class VacancyModal extends React.Component {

  closeModal = () => {
    this.props.toggleVacancyModal(false);
  }

  render() {
    return (
      <div className="vacancyModal__wrapper">
        <Modal
          isOpen={this.props.vacancyModalIsOpen}
          onRequestClose={this.closeModal}
          style={customStyles}>
          <div className="vacancyModal__close" onClick={this.closeModal}>
            <SVG src={closeModal} />
          </div>

          <div className="vacancyModal">
            <div className="vacancyModal__header">
              <h2 className="vacancyModal__title">{localStorage.getItem('lang') == 'ru'? 'UX UI дизайнер middle':'UX UI designer middle'}</h2>
              <p className="vacancyModal__description">{localStorage.getItem('lang') == 'ru'? 'Разработка концепции дизайна, проектирование интерфейсов, взаимодействий и пользовательских сценариев. Участие в мозговых штурмах и разработке креативных концепций различных сайтов, мобильных приложений, автоматизированных систем.':
              'Development of a design concept, design of interfaces, interactions, and user scenarios. Participation in brainstorming and the development of creative concepts for various sites, mobile applications, automated systems.'} </p>
            </div>
            <div className="vacancyModal__salary">
              <div className="vacancyModal__salary__item">
                <span className="vacancyModal__salary__label">{localStorage.getItem('lang') == 'ru'? 'Уровень зарплаты':'Salary level'}</span>
                <span className="vacancyModal__salary__value">>{localStorage.getItem('lang') == 'ru'? 'от 35 000 руб':'35 000 rub'}</span>
              </div>
              <div className="vacancyModal__salary__item">
                <span className="vacancyModal__salary__label">{localStorage.getItem('lang') == 'ru'? 'Опыт работы':'Work experience'}</span>
                <span className="vacancyModal__salary__value">{localStorage.getItem('lang') == 'ru'? '1 - 3 года':'1 -3 years'}</span>
              </div>
            </div>
            <div className="vacancyModal__body">
              <h3 className="vacancyModal__requirements">{localStorage.getItem('lang') == 'ru'? 'Требования':'Requirements'}</h3>
              <div className="vacancyModal__requirements__item">
                <span className="vacancyModal__requirements__item__mark"></span>
                <span className="vacancyModal__requirements__item__label">{localStorage.getItem('lang') == 'ru'? 'Проработка сценариев использования - логики проекта;':'Study of usage scenarios - project logic;'}</span>
              </div>

              <div className="vacancyModal__requirements__item">
                <span className="vacancyModal__requirements__item__mark"></span>
                <span className="vacancyModal__requirements__item__label">{localStorage.getItem('lang') == 'ru'? 'Проработка сценариев использования - логики проекта;':'Study of usage scenarios - project logic;'}</span>
              </div>

              <div className="vacancyModal__requirements__item">
                <span className="vacancyModal__requirements__item__mark"></span>
                <span className="vacancyModal__requirements__item__label">{localStorage.getItem('lang') == 'ru'? 'Проработка сценариев использования - логики проекта;':'Study of usage scenarios - project logic;'}</span>
              </div>
              <div className="vacancyModal__requirements__item">
                <span className="vacancyModal__requirements__item__mark"></span>
                <span className="vacancyModal__requirements__item__label">{localStorage.getItem('lang') == 'ru'? 'Проработка сценариев использования - логики проекта;':'Study of usage scenarios - project logic;'}</span>
              </div>
              <div className="vacancyModal__requirements__item">
                <span className="vacancyModal__requirements__item__mark"></span>
                <span className="vacancyModal__requirements__item__label">{localStorage.getItem('lang') == 'ru'? 'Проработка сценариев использования - логики проекта;':'Study of usage scenarios - project logic;'}</span>
              </div>
              <h3 className="vacancyModal__conditions">{localStorage.getItem('lang') == 'ru'? 'Условия':'Conditions'}</h3>
              <div className="vacancyModal__requirements__item">
                <span className="vacancyModal__requirements__item__mark"></span>
                <span className="vacancyModal__requirements__item__label">{localStorage.getItem('lang') == 'ru'? 'Проработка сценариев использования - логики проекта;':'Study of usage scenarios - project logic;'}</span>
              </div>

              <div className="vacancyModal__requirements__item">
                <span className="vacancyModal__requirements__item__mark"></span>
                <span className="vacancyModal__requirements__item__label">{localStorage.getItem('lang') == 'ru'? 'Проработка сценариев использования - логики проекта;':'Study of usage scenarios - project logic;'}</span>
              </div>

              <div className="vacancyModal__requirements__item">
                <span className="vacancyModal__requirements__item__mark"></span>
                <span className="vacancyModal__requirements__item__label">{localStorage.getItem('lang') == 'ru'? 'Проработка сценариев использования - логики проекта;':'Study of usage scenarios - project logic;'}</span>
              </div>
              <div className="vacancyModal__requirements__item">
                <span className="vacancyModal__requirements__item__mark"></span>
                <span className="vacancyModal__requirements__item__label">{localStorage.getItem('lang') == 'ru'? 'Проработка сценариев использования - логики проекта;':'Study of usage scenarios - project logic;'}</span>
              </div>
              <div className="vacancyModal__requirements__item">
                <span className="vacancyModal__requirements__item__mark"></span>
                <span className="vacancyModal__requirements__item__label">{localStorage.getItem('lang') == 'ru'? 'Проработка сценариев использования - логики проекта;':'Study of usage scenarios - project logic;'}</span>
              </div>
              <div className="vacancyModal__buttonWrapper">
                <Button>{localStorage.getItem('lang') == 'ru'? 'Откликнуться':'To respond'}</Button>
              </div>

            </div>
          </div>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = ({ vacancyModalIsOpen }) => {
  return {
    vacancyModalIsOpen
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleVacancyModal: (flag) => dispatch(toggleVacancyModal(flag))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VacancyModal);


// WEBPACK FOOTER //
// ./src/components/vacancyModal/index.jsx